import posed, { PoseGroup } from 'react-pose'
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const WIDTH = 500
const HEIGHT = 600
const RADIUS_CLOSED = 200
const RADIUS_OPENED = 160

const Item = posed.div({
    close: {
        left: 0,
        marginLeft: 0,
        width: RADIUS_CLOSED,
        height: RADIUS_CLOSED,
        marginTop: -(RADIUS_CLOSED / 2),
        top: '50%',
        opacity: props => {
            if (props.itemIndex !== 0) {
                return 0
            }
            return 1
        },
    },
    open: {
        opacity: 1,
        left: '100%',
        marginLeft: props => {
            if (props.itemIndex === 2) {
                return -RADIUS_OPENED
            }
            return -RADIUS_OPENED - RADIUS_OPENED / 2
        },
        width: RADIUS_OPENED,
        height: RADIUS_OPENED,
        marginTop: 0,
        delay: props => 100 * props.itemIndex,
        top: props => {
            const tileHeight = HEIGHT / 3
            return tileHeight * (props.itemIndex - 1) + (tileHeight - RADIUS_OPENED) / 2
        },
        transition: { type: 'spring', stiffness: 200, damping: 15 },
    },
})

const Line = posed.div({
    close: {
        left: RADIUS_CLOSED / 2,
        width: 0,
        top: '50%',
    },
    open: {
        width: props => {
            if (props.itemIndex === 1 || props.itemIndex === 3) {
                return WIDTH - RADIUS_CLOSED / 2 - RADIUS_OPENED / 2 - RADIUS_OPENED / 2
            }
            return WIDTH - RADIUS_CLOSED / 2 - RADIUS_OPENED / 2
        },
        delay: props => 100 * props.itemIndex,
        bottom: '50%',
        top: props => {
            const tileHeight = HEIGHT / 3
            return tileHeight * (props.itemIndex - 1) + (tileHeight - RADIUS_OPENED) / 2 + RADIUS_OPENED / 2
        },
    },
})

class AnimatedMenu extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            items: this.props.items,
            itemIndexRingAnimation: null,
            pose: 'close',
        }
    }

    componentDidMount() {
        this.setRingAnimationTimer()
        setTimeout(() => {
            this.setState({
                pose: 'open',
            })
        }, 1000)
    }

    componentWillUnmount() {
        this.resetRingAnimationTimer()
    }

    itemClicked(itemIndex) {
        let newPose = null

        switch (this.state.pose) {
            case 'open':
                newPose = 'close'
                break

            default:
                newPose = 'open'
                break
        }

        if (this.state.pose !== newPose) {
            let newState = {
                pose: newPose,
            }

            if (this.state.pose === 'open' && itemIndex > 0) {
                let items = [this.state.items[itemIndex]]
                this.state.items.map((item, index) => {
                    if (itemIndex !== index) {
                        items.push(item)
                    }
                })
                newState.items = items

                setTimeout(() => {
                    this.setState({
                        pose: 'open',
                    })
                    setTimeout(() => {
                        this.setRingAnimationTimer()
                    }, 500)
                }, 300)

                if (this.props.itemClick) {
                    this.props.itemClick(items[0])
                }
            }

            this.setState(newState, () => {
                this.setRingAnimationTimer()
            })
        }
    }

    setRingAnimationTimer() {
        this.resetRingAnimationTimer()
        this.timer = setInterval(() => {
            this.setRingAnimationItemIndex()
        }, 6000)
        this.setRingAnimationItemIndex()
    }

    resetRingAnimationTimer() {
        clearInterval(this.timer)
    }

    setRingAnimationItemIndex() {
        if (this.state.pose === 'open') {
            let nextIndex = 1
            if (this.state.itemIndexRingAnimation > 0 && this.state.itemIndexRingAnimation <= 2) {
                nextIndex = this.state.itemIndexRingAnimation + 1
            }
            this.setState({
                itemIndexRingAnimation: nextIndex,
            })
        } else {
            this.setState({
                itemIndexRingAnimation: 0,
            })
        }
    }

    render() {
        const lineStyles = [componentStyle.itemLine1, componentStyle.itemLine2, componentStyle.itemLine3]

        return (
            <div style={this.props.style ? { ...componentStyle.root, ...this.props.style } : componentStyle.root}>
                <PoseGroup>
                    {this.state.items.map((item, index) => (
                        <Fragment key={index}>
                            {index > 0 && <Line itemIndex={index} className={'circle-line'} style={lineStyles[index - 1]} pose={index > 0 ? this.state.pose : 'close'} />}
                            <Item
                                className={this.state.itemIndexRingAnimation === index ? (this.state.itemIndexRingAnimation === 0 ? 'pulse pulse-red' : 'pulse') : ''}
                                itemIndex={index}
                                onClick={() => this.itemClicked(index)}
                                style={{ ...componentStyle.item, zIndex: index === 0 ? 10 : 2, backgroundColor: index === 0 ? '#ce233c' : '#ffffff' }}
                                pose={index > 0 ? this.state.pose : 'close'}
                            >
                                <div style={{ ...componentStyle.label, color: index === 0 ? '#ffffff' : '#ce233c' }}>
                                    <span style={componentStyle.labelInner}>{item.title}</span>
                                </div>
                            </Item>
                        </Fragment>
                    ))}
                </PoseGroup>
            </div>
        )
    }
}

AnimatedMenu.propTypes = {
    items: PropTypes.array,
    itemClick: PropTypes.func,
}

export default AnimatedMenu

const componentStyle = {
    root: {
        width: WIDTH,
        height: HEIGHT,
        position: 'relative',
        marginLeft: 100,
    },
    item: {
        left: 0,
        backgroundColor: 'red',
        position: 'absolute',
        zIndex: 2,
        borderRadius: '50%',
        cursor: 'pointer',
    },
    label: {
        color: '#fff',
        fontSize: 22,
        fontWeight: 'bold',
        textAlign: 'center',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    labelInner: {
        padding: 10,
    },
    itemLine1: {
        position: 'absolute',
        zIndex: 1,
        borderTop: '3px solid #fff',
        transform: 'rotate(-38deg)',
        transformOrigin: '100% 0%',
    },
    itemLine2: {
        position: 'absolute',
        zIndex: 1,
        borderTop: '3px solid #fff',
    },
    itemLine3: {
        position: 'absolute',
        zIndex: 1,
        borderTop: '3px solid #fff',
        transform: 'rotate(38deg)',
        transformOrigin: '100% 0%',
    },
}
